(function() {
   

    function initVideos() {
        const root = document.querySelector('.collection-video-slider.swiper');
        
        if (!root || root.dataset.videoInit) return;
        
        if (typeof Swiper === 'undefined') {
            setTimeout(initVideos, 100);
            return;
        }

        
        
        const swiper = new Swiper(root, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
                nextEl: root.querySelector('.swiper-button-next'),
                prevEl: root.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                767: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                    centeredSlides: true,
                    grabCursor: false,
                    simulateTouch: false,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                    centeredSlides: true,
                    grabCursor: false,
                    simulateTouch: false,
                }
            },
            a11y: true,
            on: {
                init: function() {
                    
                    
                    // Load initial + adjacent videos
                    loadVideo(this.slides[this.activeIndex]);
                    if (this.slides[this.activeIndex + 1]) loadVideo(this.slides[this.activeIndex + 1]);
                    if (this.slides[this.activeIndex - 1]) loadVideo(this.slides[this.activeIndex - 1]);

                    // Hide active poster
                    setTimeout(() => {
                        const activeSlide = this.slides[this.activeIndex];
                        const activePoster = activeSlide?.querySelector('.video-poster-image');
                        if (activePoster) {
                            activePoster.style.opacity = '0';
                            activePoster.style.pointerEvents = 'none';
                        }
                    }, 500);
                },
                slideChange: function() {
                    
                    
                    // Load adjacent videos if not loaded
                    loadVideo(this.slides[this.activeIndex]);
                    if (this.slides[this.activeIndex + 1]) loadVideo(this.slides[this.activeIndex + 1]);
                    if (this.slides[this.activeIndex - 1]) loadVideo(this.slides[this.activeIndex - 1]);

                    // Poster toggle
                    this.slides.forEach((slide, index) => {
                        const poster = slide.querySelector('.video-poster-image');
                        if (poster) {
                            if (index === this.activeIndex) {
                                poster.style.opacity = '0';
                                poster.style.pointerEvents = 'none';
                            } else {
                                poster.style.opacity = '1';
                                poster.style.pointerEvents = 'auto';
                            }
                        }
                    });
                }
            }
        });

        // Intersection observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    
                }
            });
        }, { threshold: 0.3 });

        observer.observe(root);
        root.dataset.videoInit = "1";

        setupVideoPopup();
    }

    function loadVideo(slide) {
        if (!slide) return;
        
        const card = slide.classList.contains('product-video-card') ? slide : slide.querySelector('.product-video-card');
        const container = slide.querySelector('.iframe-container');
        
        // Check if already loaded
        if (!container || container.dataset.loaded === 'true') {
            return;
        }
        
        const videoUrl = card?.dataset.videoUrl;
        if (!videoUrl) return;

        // Automatically fetch title from card's data attribute or text content
        const titleText = card.dataset.videoTitle || 
                        card.querySelector(".product-video-info h3")?.textContent?.trim() || 
                        card.querySelector(".product-video-info .title")?.textContent?.trim() || 
                        card.querySelector(".product-video-info p")?.textContent?.trim() || 
                        "Product Video";
        
        const iframe = document.createElement('iframe');
        iframe.src = videoUrl + '?background=%23000000&autoplay=true&loop=true&mute=true&controls=false&tr=w-400&playsinline=1';
        iframe.width = '100%';
        iframe.height = '327';
        iframe.frameBorder = '0';
        iframe.allow = 'autoplay; muted';
        iframe.allowFullscreen = false;
        iframe.title = titleText;  // ✅ Auto-fetched title
        
        container.appendChild(iframe);
        container.dataset.loaded = 'true';
    }

    function setupVideoPopup() {
        const popup = document.getElementById("video-popup");
        const popupIframe = document.getElementById("popup-iframe");
        const btnClose = document.getElementById("video-close");
        const btnNext = document.getElementById("video-next");
        const btnPrev = document.getElementById("video-prev");
        
        if (!popup) return;

        let currentIndex = 0;
        const videoCards = document.querySelectorAll(".product-video-card");
        const videoList = Array.from(videoCards).map(card => card.dataset.videoUrl);

        document.querySelectorAll(".product-video-wrapper").forEach((wrapper, index) => {
            wrapper.addEventListener("click", () => {
                currentIndex = index;
                openPopup();
            });
        });

        function buttonLinkChange() {
            const buttonContainer = popup.querySelector('.video-iframe-button');
            buttonContainer.innerHTML = "";

            const clickedCard = videoCards[currentIndex];
            const originalButton = clickedCard.querySelector(".product-video-info > a");

            if (originalButton) {
                buttonContainer.appendChild(originalButton.cloneNode(true));
            }
        }
        
        function openPopup() {
            document.body.classList.add('overflow-hidden');
            popup.style.display = "flex";
            popup.style.opacity = 1;
            playVideo(currentIndex);
            buttonLinkChange();
        }

        function closePopup() {
            document.body.classList.remove('overflow-hidden');
            popup.style.display = "none";
            popupIframe.src = "";
        }

        function playVideo(index) {
            const videoUrl = videoList[index];
            popupIframe.src = `${videoUrl}?background=%23000000&autoplay=true&loop=true&mute=true&controls=true&tr=w-400&playsinline=1`;
            buttonLinkChange();
        }

        btnNext.addEventListener("click", () => {
            currentIndex = (currentIndex + 1) % videoList.length;
            playVideo(currentIndex);
        });

        btnPrev.addEventListener("click", () => {
            currentIndex = (currentIndex - 1 + videoList.length) % videoList.length;
            playVideo(currentIndex);
        });

        btnClose.addEventListener("click", closePopup);
        popup.addEventListener("click", (e) => {
            if (e.target === popup) closePopup();
        });
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape") closePopup();
        });
    }

    // Initialize
    document.addEventListener("DOMContentLoaded", initVideos);
    if (document.readyState !== 'loading') {
        initVideos();
    }
})();



// function initVideoSwiper() {
//     const root = document.querySelector('.collection-video-slider.swiper');
//     if (!root || root.dataset.swiperInit) return;
//     if (typeof Swiper === 'undefined') {
//         setTimeout(initVideoSwiper, 100);
//         return;
//     }

//     const swiper = new Swiper(root, {
//         slidesPerView: 1,
//         spaceBetween: 0,
//         loop: true,
//         navigation: {
//             nextEl: root.querySelector('.swiper-button-next'),
//             prevEl: root.querySelector('.swiper-button-prev'),
//         },
//         breakpoints: {
//             767: {
//                 slidesPerView: 3,
//                 spaceBetween: 20,
//                 centeredSlides: true,
//                 grabCursor: false,
//                 simulateTouch: false,
//             },
//             1024: {
//                 slidesPerView: 5,
//                 spaceBetween: 20,
//                 centeredSlides: true,
//                 grabCursor: false,
//                 simulateTouch: false,
//             }
//         },
//         a11y: true,
//         on: {
//             slideChange: (swiperInstance) => {
//                 setTimeout(() => autoplayVisibleVideo(swiperInstance), 100);

//             }
//         }
//     });

//     const observer = new IntersectionObserver((entries) => {
//         entries.forEach(entry => {
//             if (entry.isIntersecting) {
//                 autoplayVisibleVideo(swiper);
//             } 
//             // else {
//             //     if (window.innerWidth < 768) {
//             //         setTimeout(() => {
//             //             stopAllVideos()
//             //         },5000)
//             //     }
//             // }
//         });
//     }, {
//         threshold: 0.5
//     });

//     observer.observe(root);
//     root.dataset.swiperInit = "1";
// }

// function autoplayVisibleVideo(swiper) {
//     const root = document.querySelector('.collection-video-slider.swiper');

//     const rect = root.getBoundingClientRect();
//     const isMostlyVisible = rect.top < window.innerHeight && rect.bottom > 0;
//     if (!isMostlyVisible) return;

//     const activeSlide = swiper.slides[swiper.activeIndex];
//     if (!activeSlide) return;

//     const iframe = activeSlide.querySelector("iframe");
//     if (!iframe) return;

//     const baseSrc = iframe.dataset.originalSrc || iframe.src.split("?")[0];
//     const autoplaySrc = `${baseSrc}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=false&tr=w-400`;

//     // Do nothing if it's already autoplaying
//     if (iframe.src === autoplaySrc) return;

//     // Stop videos in all other slides
//     swiper.slides.forEach((slide, index) => {
//         if (index !== swiper.activeIndex) {
//             const otherIframe = slide.querySelector("iframe");
//             if (otherIframe && otherIframe.src.includes("autoplay=true")) {
//                 const original = otherIframe.dataset.originalSrc || otherIframe.src.split("?")[0];
//                 otherIframe.src = original;
//             }
//         }
//     });

//     // Set autoplay src for active iframe
//     iframe.src = autoplaySrc;
//     iframe.dataset.originalSrc = baseSrc;
// }

// function stopAllVideos() {
//     const iframes = document.querySelectorAll(".product-video-card iframe");
//     iframes.forEach(iframe => {
//         if (iframe.dataset.originalSrc) {
//             iframe.src = iframe.dataset.originalSrc;
//         }
//     });
// }


// document.addEventListener("DOMContentLoaded", function () {
//     initVideoSwiper();

//     const videoCards = document.querySelectorAll(".product-video-card iframe");
//     let currentPlaying = null;

//     // Popup setup
//     const popup = document.getElementById("video-popup");
//     const popupIframe = document.getElementById("popup-iframe");
//     const btnClose = document.getElementById("video-close");
//     const btnNext = document.getElementById("video-next");
//     const btnPrev = document.getElementById("video-prev");
//     let currentIndex = 0;

//     const videoList = Array.from(videoCards).map(iframe => {
//         const base = iframe.dataset.originalSrc || iframe.src?.split("?")[0];
//         return base;
//     });

//     document.querySelectorAll(".product-video-wrapper").forEach((card, index) => {
//         card.addEventListener("click", () => {
//             if (currentPlaying) {
//             currentPlaying.src = currentPlaying.dataset.originalSrc;
//             currentPlaying = null;
//             }
//             currentIndex = index;
//             openPopup();
//         });
//     });

//     function buttonLinkChange() {
//         const buttonContainer = popup.querySelector('.video-iframe-button');
//         buttonContainer.innerHTML = "";

//         const clickedCard = document.querySelectorAll(".product-video-card")[currentIndex];
//         const originalButton = clickedCard.querySelector(".product-video-info > a");

//         if (originalButton) {
//             const clonedButton = originalButton.cloneNode(true);
//             buttonContainer.appendChild(clonedButton);
//         }
//     }
    
//     function openPopup() {
//         document.body.classList.add('overflow-hidden');
//         popup.style.display = "flex";
//         playVideo(currentIndex);
//         buttonLinkChange()
//     }

//     function closePopup() {
//         document.body.classList.remove('overflow-hidden');
//         popup.style.display = "none";
//         popupIframe.src = "";
//     }

//     function playVideo(index) {
//         popupIframe.src = `${videoList[index]}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=false&tr=w-400`;
//         const basePopupIframeSrc = popupIframe.src?.split("?")[0]
//         popupIframe.src = `${basePopupIframeSrc}?background=%23ffffff&autoplay=true&loop=true&mute=true&controls=true&tr=w-400`;
//         buttonLinkChange()
//     }

//     btnNext.addEventListener("click", () => {
//         currentIndex = (currentIndex + 1) % videoList.length;
//         playVideo(currentIndex);
//     });

//     btnPrev.addEventListener("click", () => {
//         currentIndex = (currentIndex - 1 + videoList.length) % videoList.length;
//         playVideo(currentIndex);
//     });

//     btnClose.addEventListener("click", closePopup);
//         popup.addEventListener("click", (e) => {
//         if (e.target === popup) closePopup();
//         });
//         document.addEventListener("keydown", (e) => {
//         if (e.key === "Escape") closePopup();
//     });

// });
